import { render, staticRenderFns } from "./ButtonBack.vue?vue&type=template&id=5a290d56&scoped=true&"
import script from "./ButtonBack.vue?vue&type=script&lang=js&"
export * from "./ButtonBack.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBack.vue?vue&type=style&index=0&id=5a290d56&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a290d56",
  null
  
)

export default component.exports